const URL = process.env.NODE_ENV === 'production' ? 'https://grupoeuromotors.online:450/' : 'http://localhost:8000/';
export default URL; 